<div class="row g-0 gx-2">
  <div class="col-12 d-flex flex-column">
    @for (messageStatus of terminalMessageStatuses; track messageStatus) {
      @if (messageStatus.messages?.length) {
        @if (this.messageStatus !== 'DISABLED') {
          <button (mouseover)="hoverServiceStatusSpan(_serviceStatusSpanId, true)"
            (mouseout)="hoverServiceStatusSpan(_serviceStatusSpanId, false)"
            id="{{_serviceStatusButtonId}}" onPopover data-bs-toggle="popover" [popoverContent]="popoverContent"
            placement="top" popoverClass="pop-auto-container" [popoverData]="messageStatus"
            class="btn btn-link link-dark p-0 row g-0 d-flex">
            <span class="col-7 text-truncate">{{messageStatus.name | sentenceCase}}</span>
            <app-task-message-status-icon class="col-auto" [messageStatus]="messageStatus.taskStatus"></app-task-message-status-icon>
            <span class="col text-truncate text-start">{{messageStatus.customLabel}}</span>
          </button>
        }
      } @else {
        <div class="row g-0">
          <span class="col-7 text-truncate">{{ messageStatus.name | sentenceCase }}</span>
          <app-task-message-status-icon class="col-auto d-flex align-items-center"
          [messageStatus]="messageStatus.taskStatus"></app-task-message-status-icon>
          <span class="col text-truncate">{{ messageStatus.customLabel }}</span>
        </div>
      }
    }
  </div>
</div>

<ng-template #popoverContent let-data="$implicit">
  <div class="w-100 h-100 text-start p-1 pe-4" style="min-width: 360px; max-width: 360px;">
    <div class="btn-close-wrapper rounded-circle position-absolute end-0 top-0 mt-2 me-2">
      <button type="button" class="btn-close" data-bs-toggle="popover" aria-label="Close"></button>
    </div>
    <span class="d-block fw-medium mb-2">{{ data.name | sentenceCase }}</span>
    @if (data.taskStatus !== 'DISABLED') {
      <div class="message-status d-flex mb-2 flex-column align-items-stretch">
        <div class="d-inline-flex flex-grow-1 flex-column row g-2">
          @for (message of data.messages; track message) {
            <div class="d-flex col-12">
              <i class="fa fa-fw fa-light fa-comment me-1 d-flex-inline"></i>
              <span class="d-flex-inline" style="line-height: 1.25rem">{{ message }}</span>
            </div>
          }
        </div>
      </div>
    }
  </div>
</ng-template>
